import React, { useState, Suspense } from "react"
import { Outlet } from "react-router-dom"
import { Box, Stack } from "@mui/material"
import { StudentHeaderView as Header } from "components/Header/StudentHeader.view"
import { StudentSidebarView as SidebarDrawer } from "components/SidebarDrawer/StudentSidebar.view"
import Loading from "components/Loading"
import { styles } from "./StudentLayout.styles"
import { GamesRouteProviders } from "routers/GamesRouteProviders"

export const StudentLayoutUI = ({ hideNavigation }) => {
  const [drawerOpen, setDrawerOpen] = useState(false)

  if (hideNavigation) {
    return (
      <Suspense fallback={<Loading />}>
        <GamesRouteProviders>
          <Outlet />
        </GamesRouteProviders>
      </Suspense>
    )
  }

  return (
    <Box>
      <SidebarDrawer open={drawerOpen} onClose={() => setDrawerOpen(false)} />
      <Stack component="main" sx={styles.main} className="student-layout">
        <Header onMenuClick={() => setDrawerOpen(true)} />
        <Suspense fallback={<Loading />}>
          <GamesRouteProviders>
            <Outlet />
          </GamesRouteProviders>
        </Suspense>
      </Stack>
    </Box>
  )
}
